import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Constant } from '../auth/Constant';
import { finalize, Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  isLoading: boolean;

  constructor(
    private apiService: ApiService,
  ) {

  }


  private checkLgLocalStorage(): any | null {
    const lgList = localStorage.getItem(Constant.LOCAL_GOVERNMENT_LIST);
    return lgList ? JSON.parse(lgList) : null;
  }

  getLocalGovernmentList(): Observable<any> {
    const cachedData = this.checkLgLocalStorage();

    if (cachedData && cachedData.length > 0) {
      return of(cachedData); // Return cached data as an Observable
    }

    this.isLoading = true;
    const url = '/utility/all/lga';

    return this.apiService.get(url).pipe(
      finalize(() => {
        this.isLoading = false;
      }),
      tap((response) => {
        localStorage.setItem(Constant.LOCAL_GOVERNMENT_LIST, JSON.stringify(response));
      })
    );
  }


  getZonesFromLga(lga) {
    return this.apiService.get('/utility/all/zone/' + lga);
  }




}

